import { IS_CLIENT } from '@repo/common-utils';

import { useWorkingPlatform } from './use-working-platform';

export const useWindowOpen = () => {
  const { workingPlatform, workingPlatformType } = useWorkingPlatform();

  const openWindow = (link: string, target?: string) => {
    if (IS_CLIENT) {
      target = workingPlatform === 'kbank' ? '_system' : target;
      window.open(link, target ?? (workingPlatformType === 'web' ? '_blank' : '_system'));
    }
  };

  return {
    openWindow
  };
};
